import { ShoppingBag, Euro, Receipt } from "lucide-react";

export const fmt = (v) => `${Number(v ?? 0).toFixed(2)}€`;

export function MetricCard({ icon: Icon, label, value, accent = false }) {
  return (
    <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`w-4 h-4 ${accent ? "text-emerald-500" : "text-gray-400"}`} />
        <span className="text-xs text-gray-400 uppercase tracking-wide">{label}</span>
      </div>
      <p className={`text-2xl font-bold ${accent ? "text-emerald-700" : "text-gray-800"}`}>{value}</p>
    </div>
  );
}

export function KarolMetricsCards({ ordersToday, revenueToday, avgTicketToday }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
      <MetricCard icon={ShoppingBag} label="Pedidos hoje" value={ordersToday ?? 0} accent />
      <MetricCard icon={Euro}        label="Receita hoje" value={fmt(revenueToday)} />
      <MetricCard icon={Receipt}     label="Ticket médio" value={fmt(avgTicketToday)} />
    </div>
  );
}
